"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledToast = void 0;
var _Toast = require("./Toast");
// TODO: in v9, move styled() from Toast.jsx to here
var StyledToast = _Toast.Toast;
exports.StyledToast = StyledToast;